<template>
  <div class="blank">
    <img src="@/assets/images/no_data.png">
  </div>
</template>

<script lang="js">
  export default {
    name: "Blank"
  }
</script>

<style lang="scss" scoped>
  .blank {
    width: 100%;
    height: 500px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
